const GraphDashboardContants = {
  GET_DASHBOARD_GRAPH_SUCCESS: "GET_DASHBOARD_GRAPH_SUCCESS",
  GET_DASHBOARD_GRAPH_FAILURE: "GET_DASHBOARD_GRAPH_FAILURE",

  GET_DASHBOARD_GRAPH_EQUIPMENTSTATUS_SUCCESS:
    "GET_DASHBOARD_GRAPH_EQUIPMENTSTATUS_SUCCESS",
  GET_DASHBOARD_GRAPH_EQUIPMENTSTATUS_FAILURE:
    "GET_DASHBOARD_GRAPH_EQUIPMENTSTATUS_FAILURE",
  GET_INSPECTION_KPI_DATA_SUCCESS: "GET_INSPECTION_KPI_DATA_SUCCESS",
  GET_INSPECTION_KPI_DATA_FAILURE: "GET_INSPECTION_KPI_DATA_FAILURE",

  GET_TICKET_KPI_DATA_SUCCESS: "GET_TICKET_KPI_DATA_SUCCESS",
  GET_TICKET_KPI_DATA_FAILURE: "GET_TICKET_KPI_DATA_FAILURE",

  GET_EQUIPMENT_TICKET_KPI_DATA_SUCCESS:
    "GET_EQUIPMENT_TICKET_KPI_DATA_SUCCESS",
  GET_EQUIPMENT_TICKET_KPI_DATA_FAILURE:
    "GET_EQUIPMENT_TICKET_KPI_DATA_FAILURE",

  GET_ORG_KPI_DATA_SUCCESS: "GET_ORG_KPI_DATA_SUCCESS",
  GET_ORG_KPI_DATA_FAILURE: "GET_ORG_KPI_DATA_FAILURE",

  GET_DASHBOARD_SUMMARY_DATA_SUCCESS: "GET_DASHBOARD_SUMMARY_DATA_SUCCESS",
  GET_DASHBOARD_SUMMARY_DATA_FAILURE: "GET_DASHBOARD_SUMMARY_DATA_FAILURE",
};
export default GraphDashboardContants;
